import { lazy } from "react";
export var LazyCategoryLandingPage = lazy(function() {
    return import(/* webpackChunkName: "brands-category" */ "@faire/retailer-visitor-shared/views/brands/personalized-landing-page/CategoryLandingPage").then(function(m) {
        return {
            default: m.CategoryLandingPage
        };
    });
});
